import { render, staticRenderFns } from "./StatInspItemNotes.vue?vue&type=template&id=708e6956"
import script from "./StatInspItemNotes.vue?vue&type=script&lang=js"
export * from "./StatInspItemNotes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports